import React from 'react'
import PropTypes from 'prop-types'
import {ListGroupSubheader as RmwcListGroupSubheader} from '@rmwc/list'
import '@rmwc/list/styles'

const DrawerListGroupSubheader = ({children, ...otherProps}) => <RmwcListGroupSubheader {...otherProps}>{children}</RmwcListGroupSubheader>

DrawerListGroupSubheader.propTypes = {
  children: PropTypes.any
}

export {DrawerListGroupSubheader}
